import moment from "moment";
import { useEffect } from "react";
import { useQuery } from 'react-query';
import { useQueryClient } from 'react-query';

import styled from 'styled-components';

import MainTemplate from "../pages/front/MainTemplate";
import Login from "../components/front/Login";



const MainWrap = styled.div`
    // width: calc(100% - 24px);
    // padding: 12px;
    font-family: Pretendard;
    font-weight: 400;
    @media all and ${({ theme }) => theme.windowSize.base} {
        font-size: ${({ theme }) => theme.fontSize.base};
    }
    @media all and ${({ theme }) => theme.windowSize.sm} {
        font-size: ${({ theme }) => theme.fontSize.base};
    }
    @media all and ${({ theme }) => theme.windowSize.lg} {
        font-size: ${({ theme }) => theme.fontSize.lg};
    }
    transition: all ease-in 0.3s;
`;

const MainContainer = ({target}) => {

    const queryClient = useQueryClient();
    const { data : {uid} } = useQuery('USER', {initialData:{}});

    useEffect(()=>{
        if(!uid){
            const targetInfo = localStorage.getItem('USER');

            if(targetInfo){
                const conv = JSON.parse(targetInfo);
                if(conv.ex_date > moment().format("yyyyMMDDHHmmss")){
                    queryClient.setQueryData('USER',conv);
                }
            }
        }
    },[target])

return (
        <MainWrap>
            {uid ? <MainTemplate target={target}/> : <Login />}
        </MainWrap>
    )
}

export default MainContainer;